exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.submit-file[data-v-36deb2b7]{width:8.375rem;height:2.6875rem;background:linear-gradient(89deg, #fdcf00 0%, #fdb100 100%);opacity:1;border-radius:1.3125rem;margin-bottom:2.6875rem\n}", "", {"version":3,"sources":["C:/Users/Administrator/Documents/hbt-ielts-client-pc-web/src/components/mycenter_studyabroad/component/tab_six.vue"],"names":[],"mappings":";AACA,8BAA8B,eAAe,iBAAiB,4DAA4D,UAAU,wBAAwB,uBAAuB;CAClL","file":"tab_six.vue","sourcesContent":["\n.submit-file[data-v-36deb2b7]{width:8.375rem;height:2.6875rem;background:linear-gradient(89deg, #fdcf00 0%, #fdb100 100%);opacity:1;border-radius:1.3125rem;margin-bottom:2.6875rem\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36deb2b7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mycenter_studyabroad/component/tab_six.vue
// module id = dOS1
// module chunks = 1